module.exports = __webpack_public_path__ + "img/service-sec03-img02.2139cb39.jpg";